import { Link } from 'react-router-dom';
import { useState } from 'react';
import { seoArticles } from '@/mocks/siteData';

export default function SEOArticleCluster() {
  const [showAll, setShowAll] = useState(false);
  const displayedArticles = showAll ? seoArticles : seoArticles.slice(0, 6);

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950">
            Sourcing Guides &amp; Reviews
          </h2>
          <p className="mt-3 text-foreground-600 text-base max-w-lg mx-auto">
            Expert insights on itaobuy spreadsheet system, cross-border sourcing strategies, and product discovery tips
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {displayedArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group block rounded-2xl border border-background-200/70 bg-background-50 overflow-hidden hover:border-foreground-300 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[3/2] overflow-hidden bg-background-100">
                <img
                  src={article.image}
                  alt={`Itaobuy spreadsheet article - ${article.title}`}
                  title={`Itaobuy Spreadsheet Guide - ${article.title}`}
                  className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1.5 mt-3 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                  Read Article
                  <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center flex flex-col sm:flex-row gap-3 items-center justify-center">
          {!showAll && seoArticles.length > 6 && (
            <button
              onClick={() => setShowAll(true)}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-foreground-300 text-foreground-700 text-sm font-medium hover:bg-foreground-950 hover:text-background-50 hover:border-foreground-950 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              Show All {seoArticles.length} Guides
              <i className="ri-arrow-down-line w-4 h-4 flex items-center justify-center"></i>
            </button>
          )}
          <Link
            to="/article/what-is-itaobuy-spreadsheet"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-primary-200 bg-primary-50 text-sm font-medium text-primary-700 hover:bg-primary-100 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Start Reading
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}